<template>
<table v-if="table" style="border-collapse:collapse;">
    <tr>
        <td v-for="field in table.fields" class="no-wrap" :class="cellClass(field)" style="color:#777;font-weight:bolder;padding:8px;max-width:150px;border-bottom:solid 1px #ddd" :key="'hdr-' + field.name">
            {{field.title}}
        </td>
    </tr>
    <tr class="hoverable" v-for="record in table.records" :key="record['.key']">
        <td v-for="(field) in table.fields" class="no-wrap" :class="cellClass(field)" style="color:#444;padding:7px 12px;max-width:150px;border-bottom:solid 1px #ddd" :key="field.name">
            {{record[field.name]}}
        </td>
    </tr>
</table>    

</template>

<script>


import ScreenData from './ScreenData'

export default {
    data() {
        return {

            
        }
    },
    components: {
   
    },
    
    props: {
        table: Object,
    },

    computed: {
        xxx() {
            return null
        }
    },

    methods: {
        formatForDisplay(value, type) {
            return ScreenData.formatForDisplay(value, type)
        },
        cellClass(field) {
            return {
                'text-xs-right': field.align == 'right'
            }
        },
    },

    mounted() {
    
    }

}
</script>

<style scoped>
    
   
</style>




// WEBPACK FOOTER //
// ScreenTable.vue?e632666e